import { AbstractControl, ValidationErrors } from '@angular/forms';

export interface Municipality {
    codigo: string;
    descripcion: string;
    provincia?: Province;
}

export interface Province {
    codigo: string;
    descripcion: string;
}

export interface Locality {
    codigo: string;
    descripcion: string;
    municipio?: Municipality;
    provincia?: Province;
}


export function localityRequiredValidator(control: AbstractControl): ValidationErrors {
    const value = control.value as Locality | null;
    if (!value?.codigo || !value?.municipio?.codigo || !value?.provincia?.codigo) {
        return { required: true };
    }
    return {};
}
